const content = {
  title: "SOP Report",
  table: {
    nameNumber: "Name / Number",
    ppv: "PPV",
    customerPv: "Customer PV",
    currentSopPv: "Current SOP PV",
    expectedSopPv: "Expected SOP PV",
    sopProducts: "SOP Products",
    viewSopProducts: "View SOP Products",
  },
  tabs: {
    orderRenewal: "SOP Order Renewal ({count})",
    sopPvThisMonth: "SOP PV This Month ({count})",
    noSopPvThisMonth: "No SOP PV This Month ({count})",
  },
  overviewTitle: "Group SOP Overview",
  overviewCard: {
    currentSopPv: "Current SOP PV",
    expectedSopPv: "Expected SOP PV",
    ordersUpForRenewal: "SOP orders up for renewal",
    totalDownlinesOnSop: "Total ABOs / Customers on SOP",
    genSopPvThisMonth: "Generating SOP PV this month",
    notGenSopPvThisMonth: "Not generating SOP PV this month",
    percentGroupOnSop: "Percent of group on SOP",
  },
  exportModal: {
    title: "Export Report",
    description:
      "This report will include a list of all ABOs/Customers which are on SOP or have a SOP Order up for renewal.",
    cancelButton: "Cancel",
    exportButton: "Export",
  },
};

export default content;
